module.exports = __webpack_public_path__ + "img/1210 MK7 EX.6c61564b.png";